/**
 * The till's money screen, refused for a business that keeps no counter cash.
 *
 * A courier (deliveries without Sales & POS or Inventory) has no "Money &
 * cash" in its menu; this covers the old address, a bookmark and a link from
 * somewhere else, and points to where its money is. The API refuses as well —
 * this is so the person sees why. Nothing recorded is touched.
 *
 * When the module list cannot be read the screen is let through and the API
 * decides, as RequireModule does.
 */

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { keepsCounterCash } from '@cenox/shared';
import { useModules } from '../lib/modules';
import { Card, Spinner } from './ui';

export function RequireCounterCash({ children }: { children: ReactNode }): ReactNode {
  const { active, known, isLoading } = useModules();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (!known || keepsCounterCash(active)) return <>{children}</>;

  return (
    <Card className="mx-auto mt-6 max-w-lg">
      <h1 className="text-base font-semibold text-slate-900">Money &amp; cash is for businesses that sell at a counter</h1>
      <p className="mt-1 text-sm text-slate-600">
        This business's money — delivery fees, remittance, expenses, loans, payouts and transfers — is on Cash &amp; bank.
        Nothing has been deleted.
      </p>
      <Link
        to="/finance/accounts"
        className="mt-4 inline-block rounded-lg bg-brand-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-700"
      >
        Go to Cash &amp; bank
      </Link>
    </Card>
  );
}
